"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../Schema/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const PageEditorField = props => {
  const id = props.id,
        schema = props.schema,
        uiSchema = props.uiSchema,
        formData = props.formData,
        formContext = props.formContext,
        registry = props.registry;
  const uniqueId = formData.uniqueId,
        status = formData.status,
        statusCode = formData.statusCode,
        statusMessage = formData.statusMessage,
        title = formData.title,
        createdAt = formData.createdAt,
        updatedAt = formData.updatedAt,
        deletedAt = formData.deletedAt;
  const untitled = formContext.untitled,
        parents = formContext.parents,
        languages = formContext.languages,
        currentLocale = formContext.currentLocale;
  /*
  const collapsible = uiSchema.content && uiSchema.settings;
  const expanded = currentId && currentId.startsWith('root_settings') || false
   const handleToggle = () => {
      currentId && currentId.startsWith('root_settings') && onExpand && onExpand({'id':'root'}) || onExpand && onExpand({'id':'root_settings'})
  }
  */
  // back

  const onBack = props.formContext.onBack;

  const handleBack = props => {
    onBack && onBack(props);
  }; // select


  const onSelect = props.formContext.onSelect;

  const handleSelect = props => {
    onSelect && onSelect(props);
  }; // locale


  const onLocale = props.formContext.onLocale;

  const handleLocale = props => {
    onLocale && onLocale(props);
  }; // toggle 


  const uiOptions = (0, _utils.getUiOptions)(uiSchema);
  const fieldset = uiOptions.fieldset;
  const primaryFieldset = fieldset && fieldset[0];
  const secondaryFieldset = fieldset && fieldset[1];
  const primaryId = primaryFieldset && id + "_" + primaryFieldset;
  const secondaryId = secondaryFieldset && id + "_" + secondaryFieldset;
  const _props$formContext = props.formContext,
        currentId = _props$formContext.currentId,
        onExpand = _props$formContext.onExpand,
        onToggle = _props$formContext.onToggle;
  const secondaryExpanded = secondaryId && currentId && currentId.startsWith(secondaryId);

  const handleToggle = ({
    props
  }) => {
    console.log('EDITOR toggle', id);

    if (secondaryExpanded) {
      onExpand(_extends({
        id: id
      }, props));
    } else if (secondaryId) {
      onExpand(_extends({
        id: secondaryId
      }, props));
    }
  }; // primary + secondary actions


  const primaryAction = formContext.primaryAction;

  const newUiSchema = _extends({}, uiSchema, {
    "ui:id": "editor",
    "ui:primaryId": primaryId,
    "ui:secondaryId": secondaryId,
    "ui:onToggle": handleToggle,
    "ui:editable": true,
    "ui:editing": true,
    "ui:untitled": untitled,
    "ui:title": secondaryId || title,
    "ui:parents": parents,
    "ui:primaryAction": primaryAction,
    "ui:status": formContext.status || status,
    "ui:statusLabel": formContext.statusLabel,
    "ui:statusDate": formContext.statusDate || updatedAt || createdAt || deletedAt,
    "ui:statusCode": formContext.statusCode || statusCode,
    "ui:statusMessage": formContext.statusMessage || statusMessage,
    "ui:languages": languages,
    "ui:currentLocale": currentLocale,
    "ui:onLocale": handleLocale,
    "ui:onSelect": handleSelect,
    "ui:onBack": handleBack,
    "ui:layout": "pageEditor"
  });

  const ObjectField = registry.fields.ObjectField;
  return _react.default.createElement(ObjectField, _extends({}, props, {
    uiSchema: newUiSchema
  }));
};

var _default = PageEditorField;
exports.default = _default;
module.exports = exports.default;